// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2LH5V","title":"Info_title__27k49","links":"Info_links__2rpzn","link":"Info_link__xYW4E","logo":"Info_logo__2Li_U"};